import React, { useState, useEffect } from 'react';
import {
  Button,
  Select,
  TextInput,
  Field,
  Fieldset,
  FieldBody,
  Typeahead,
  TypeaheadItem,
  TypeaheadItemSuggestion,
  FieldLabel
} from '@emorg-prd/react-standard';
import './index.css';
import BusinessLine from '../../../../api/BusinessLine';
import BusinessLineReportingUnit from '../../../../api/BusinessLineReportingUnit';
import Country from '../../../../api/Country';
import EPSBusinessLine from '../../../../api/EPSBusinessLine';
import EPSBusinessValueChain from '../../../../api/EPSBusinessValueChain';
import ProgressTabNavigator from '../ProgressTabNavigator';

function LocationBusinessLine(props) {
  let {
    country,
    businessLineAllocationList,
    epsBusinessLineAllocationList,
    onChange,
    handlePageError,
    onNavigateForward,
    onNavigateBackward,
    onSetProgressTabComplete,
  } = props;
  const [businessReportUnitDropdown, setbusinessReportUnitDropdown] = useState([]);
  const [totalAllocation, setTotalAllocation] = useState(0);
  const [totalEpsAllocation, setTotalEpsAllocation] = useState(0);
  const [epsBusinessLineDropdown, setEPSBusinessLineDropdown] = useState([]);
  const [epsBusinessValueChainDropdown, setEPSBusinessValueChainDropdown] = useState([]);
  const acceptedPercentages = new Array('0.00', '100.00');

  useEffect(() => {
    window.scrollTo(0, 0);
    if (country.id) {
      Country.get(country.id).then((countryRes) => {
        BusinessLineReportingUnit.getByCountryCode(countryRes.countryCode).then(
          (countryRUs) => {
            if (countryRUs.length !== 0) {
              countryRUs.sort((a, b) => {
                return a.company_name.localeCompare(b.company_name);
              });
              setbusinessReportUnitDropdown(countryRUs);
            } else {
              BusinessLineReportingUnit.getAll().then((allRUs) => {
                allRUs.sort((a, b) => {
                  return a.company_name.localeCompare(b.company_name);
                });
                setbusinessReportUnitDropdown(allRUs);
              }).catch((error) => {
                handlePageError(error.message);
              });
            }
          }
        ).catch((error) => {
          handlePageError(error.message);
        });
      }).catch((error) => {
        handlePageError(error.message);
      });
    }
    EPSBusinessValueChain.getAll().then((res) => {
      res.sort((a, b) => {
        return a.short_description.localeCompare(b.short_description);
      });
      setEPSBusinessValueChainDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    EPSBusinessLine.getAll().then((res) => {
      res.sort((a, b) => {
        return a.short_description.localeCompare(b.short_description);
      });
      setEPSBusinessLineDropdown(res);
    }).catch((error) => {
      handlePageError(error.message);
    });
    calculateAllocation();
    calculateEpsAllocation();
    onSetProgressTabComplete();
  }, []);

  const addBusinessLineField = () => {
    const values = [...businessLineAllocationList];
    values.push({
      businessLineCode: 0,
      businessLineName: '',
      businessLineReportUnitCompanyCode: 0,
      businessLineReportUnitName: '',
      allocationPercent: 0,
      businessLineFilteredList: [],
    });
    onChange('businessLineAllocationList', values);
  };

  const removeBusinessLineField = (index) => {
    const values = [...businessLineAllocationList];
    if (values.length > 1) {
      values.splice(index, 1);
      businessLineAllocationList.splice(index, 1);
      onChange('businessLineAllocationList', values);
      calculateAllocation();
    } else {
      const emptyBusinessLineList = [
        {
          businessLineCode: 0,
          businessLineName: '',
          businessLineReportUnitCompanyCode: 0,
          businessLineReportUnitName: '',
          allocationPercent: 0,
          businessLineFilteredList: [],
          locationId: '',
        },
      ]
      onChange('businessLineAllocationList', emptyBusinessLineList);
    }
  };
  const handleBusinessLineObjChange = (input, index, event, value = null) => {
    const allocationsListCopy = [...businessLineAllocationList];
    switch (input) {
      case 'businessLine':
        if (event.target.options[event.target.selectedIndex].id) {
          allocationsListCopy[parseInt(index)].businessLineCode =
            event.target.options[event.target.selectedIndex].id;
        } else {
          allocationsListCopy[parseInt(index)].businessLineCode = 0;
        }
        allocationsListCopy[parseInt(index)].businessLineName = event.target.value;
        break;

      case 'allocation':
        let regx = /^\d{0,3}(\.)?\d{0,2}$/;
        if (event.target.value === '' || regx.test(event.target.value)) {
          allocationsListCopy[parseInt(index)].allocationPercent = event.target.value;
          calculateAllocation();
        }
        break;
      default:
        alert('error');
    }
    onChange('businessLineAllocationList', allocationsListCopy);
  };
  const handleBusinessLineReportUnitChange = (index, event, value = null) => {
    let businessLineAllocationListCopy = [...businessLineAllocationList];
    let blAllocationObject = businessLineAllocationListCopy[parseInt(index)];
    if (event.type === 'click') {
      blAllocationObject.businessLineReportUnitCompanyCode = event.target.innerText.substr(0, 4);
      blAllocationObject.businessLineReportUnitName = value;
      BusinessLine.getByReportingUnit(
        blAllocationObject.businessLineReportUnitCompanyCode
      ).then((res) => {
        blAllocationObject.businessLineFilteredList = res;
        onChange('businessLineAllocationList', businessLineAllocationListCopy);
      }).catch((error) => {
        handlePageError(error.message);
      });
    } else if (event.type === 'change') {
      blAllocationObject.businessLineReportUnitCompanyCode = event.target.id;
      blAllocationObject.businessLineReportUnitName = event.target.value;
      onChange('businessLineAllocationList', businessLineAllocationListCopy);
    } else if (event.key === 'Enter' && value) {
      event.preventDefault();
      let reportUnitMatch = businessReportUnitDropdown.find((reportUnitOption) =>
        reportUnitOption.company_name.toLowerCase() === value.toLowerCase()
      );
      blAllocationObject.businessLineReportUnitCompanyCode = reportUnitMatch.company_code;
      blAllocationObject.businessLineReportUnitName = value;
      BusinessLine.getByReportingUnit(
        blAllocationObject.businessLineReportUnitCompanyCode
      ).then((res) => {
        blAllocationObject.businessLineFilteredList = res;
        onChange('businessLineAllocationList', businessLineAllocationListCopy);
      }).catch((error) => {
        handlePageError(error.message);
      });
    }
  };

  function calculateAllocation() {
    const values = [...businessLineAllocationList];
    let sumAllocations = values.reduce((sum, li) => +sum + +li.allocationPercent, 0);

    if (sumAllocations < 10) {
      setTotalAllocation(sumAllocations.toPrecision(3));
    } else if (sumAllocations >= 100) {
      setTotalAllocation(sumAllocations.toPrecision(5));
    } else {
      setTotalAllocation(sumAllocations.toPrecision(4));
    }
  }

  function calculateEpsAllocation() {
    const epsValues = [...epsBusinessLineAllocationList];
    let sumEPSAllocations = epsValues.reduce(
      (sum, li) => +sum + +li.epsAllocationPercent,
      0
    );

    if (sumEPSAllocations < 10) {
      setTotalEpsAllocation(sumEPSAllocations.toPrecision(3));
    } else if (sumEPSAllocations >= 100) {
      setTotalEpsAllocation(sumEPSAllocations.toPrecision(5));
    } else {
      setTotalEpsAllocation(sumEPSAllocations.toPrecision(4));
    }
  }
  const renderBusinessLineList = (businessLine) => (
    <option
      key={businessLine.business_line_code}
      id={businessLine.business_line_code}
      value={businessLine.business_line_name}
    >
      {businessLine.business_line_name}
    </option>
  );

  const renderEPSBusinessLineDropdown = (epsBusinessLine) => (
    <option
      id={epsBusinessLine.eps_business_line_id}
      key={epsBusinessLine.eps_business_line_id}
      value={epsBusinessLine.short_description}
    >
      {epsBusinessLine.short_description}
    </option>
  );

  const renderEPSBusinessValueChainDropdown = (epsValueChain) => (
    <option
      id={epsValueChain.eps_business_vc_id}
      key={epsValueChain.eps_business_vc_id}
      value={epsValueChain.short_description}
    >
      {epsValueChain.short_description}
    </option>
  );

  const addEPSBusinessLineField = () => {
    const values = [...epsBusinessLineAllocationList];
    values.push({
      eps_business_vc_id: 0,
      businessValueChain: '',
      eps_business_line_id: 0,
      businessLine: '',
      epsAllocationPercent: 0,
      epsBusinessLineFilteredList: [],
    });
    onChange('epsBusinessLineAllocationList', values);
  };

  const removeEPSBusinessLineField = (index) => {
    const values = [...epsBusinessLineAllocationList];
    if (values.length > 1) {
      values.splice(index, 1);
      epsBusinessLineAllocationList.splice(index, 1);
      onChange('epsBusinessLineAllocationList', values);
      calculateEpsAllocation();
    } else {
      const emptyEpsBusinessLineList = [
        {
          eps_business_vc_id: 0,
          businessValueChain: '',
          eps_business_line_id: 0,
          businessLine: '',
          epsAllocationPercent: 0,
        }
      ];

      onChange('epsBusinessLineAllocationList', emptyEpsBusinessLineList);
    }
  };

  const handleEPSBusinessLineObjChange = (input, index, event) => {
    let allocationsListCopy = [...epsBusinessLineAllocationList];
    let epsBusinessLineObject = allocationsListCopy[parseInt(index)];
    switch (input) {
      case 'epsBusinessValueChain':
        epsBusinessLineObject.businessValueChain = event.target.value;
        epsBusinessLineObject.eps_business_vc_id =
          event.target.options[event.target.selectedIndex].id;
        epsBusinessLineObject.businessLine = '';
        epsBusinessLineObject.eps_business_line_id = 0;
        break;

      case 'epsBusinessLine':
          epsBusinessLineObject.businessLine = event.target.value;
          if (event.target.options[event.target.selectedIndex].id) {
            epsBusinessLineObject.eps_business_line_id =
            event.target.options[event.target.selectedIndex].id;
          } else {
            epsBusinessLineObject.eps_business_line_id = 0;
          }
        break;

      case 'epsAllocation':
        let regx = /^\d{0,3}(\.)?\d{0,2}$/;
        if (event.target.value === '' || regx.test(event.target.value)) {
          epsBusinessLineObject.epsAllocationPercent = event.target.value;
          calculateEpsAllocation();
        }
        break;
      default:
        alert('error');
    }
    onChange('epsBusinessLineAllocationList', allocationsListCopy);
  };

  const handleAllocationFocus = (allocation, index, event) => {
    switch (allocation) {
      case ('allocation'):
        let allocationListCopy = [...businessLineAllocationList];
        if (event.type === 'focus' && allocationListCopy[parseInt(index)].allocationPercent === 0) {
          allocationListCopy[parseInt(index)].allocationPercent = '';
        }
        if (event.type === 'blur' && allocationListCopy[parseInt(index)].allocationPercent === '') {
          allocationListCopy[parseInt(index)].allocationPercent = 0;
        }
        onChange('businessLineAllocationList', allocationListCopy);
        break;
      case ('epsAllocation'):
        let epsAllocationListCopy = [...epsBusinessLineAllocationList];
        if (event.type === 'focus' && epsAllocationListCopy[parseInt(index)].epsAllocationPercent === 0) {
          epsAllocationListCopy[parseInt(index)].epsAllocationPercent = '';
        }
        if (event.type === 'blur' && epsAllocationListCopy[parseInt(index)].epsAllocationPercent === '') {
          epsAllocationListCopy[parseInt(index)].epsAllocationPercent = 0;
        }
        onChange('epsBusinessLineAllocationList', epsAllocationListCopy);
        break;
     default:
        break;
    }


  }

  return (
    <div className='page'>
      <div>
        <Fieldset>
          {businessLineAllocationList.map((businessLineObject, index) => (
            <Field key={`${index}`} style={{ height: '100px' }}>
              <FieldLabel></FieldLabel>
              <FieldBody>
                <div className='detail-row'>
                  <Typeahead
                    style={{ paddingLeft: '15px' }}
                    value={businessLineObject.businessLineReportUnitName}
                    onChange={(e, value) =>
                      handleBusinessLineReportUnitChange(index, e, value)
                    }
                    fieldProps={{
                      label: 'Business Line Report Unit',
                      note: country.id ? '' : 'Please select a Country from Step 1',
                    }}
                    inputProps={{
                      className: 'bs-line-category',
                      onChange: (e) => handleBusinessLineReportUnitChange(index, e),
                      onKeyPress: (e) => handleBusinessLineReportUnitChange(index, e),
                      value: businessLineObject.businessLineReportUnitName,
                      placeholder: 'Search',
                    }}
                  >
                    {businessReportUnitDropdown
                      .filter((reportUnit) =>
                        reportUnit.company_name
                          ? reportUnit.company_name.toLowerCase()
                              .includes(
                                businessLineObject.businessLineReportUnitName.trim().toLowerCase()
                              )
                          : ''
                      )
                      .map((reportUnit) => (
                        <TypeaheadItem
                          id={reportUnit.company_code}
                          key={reportUnit.company_code}
                          value={`${reportUnit.company_name}`}
                        >
                          <TypeaheadItemSuggestion>
                            <span>{`${reportUnit.company_name}`}</span>
                          </TypeaheadItemSuggestion>
                        </TypeaheadItem>
                      ))}
                  </Typeahead>
                  <Select
                    selectProps={{
                      className: 'bs-line-select',
                    }}
                    style={{ paddingLeft: '15px' }}
                    label='Business Line'
                    value={businessLineObject.businessLineName}
                    error={
                      businessLineObject.businessLineReportUnitCompanyCode &&
                      businessLineObject.businessLineCode === 0
                    }
                    onChange={(e) =>
                      handleBusinessLineObjChange('businessLine', index, e)
                    }
                  >
                    <option value=''>Select</option>
                    {businessLineObject.businessLineFilteredList.map(
                      renderBusinessLineList
                    )}
                  </Select>

                  <TextInput
                    className='bs-line-allocation'
                    label='Allocation %'
                    value={businessLineObject.allocationPercent.toString()}
                    onChange={(e) => handleBusinessLineObjChange('allocation', index, e)}
                    onFocus={(e) => handleAllocationFocus('allocation', index, e)}
                    onBlur={(e) => handleAllocationFocus('allocation', index, e)}
                    error={
                      (
                        businessLineAllocationList[parseInt(index)].businessLineReportUnitCompanyCode &&
                        (
                          businessLineAllocationList[parseInt(index)].allocationPercent == 0 || /* == includes 0 and "0" */
                          businessLineAllocationList[parseInt(index)].allocationPercent === ''
                        )
                      )
                    }
                  />

                  <Button
                    style={{ paddingTop: '42px', paddingLeft: '25px' }}
                    className='small-margin'
                    variant='tertiary'
                    size='small'
                    onClick={() => removeBusinessLineField(index)}
                  >
                    × Remove Allocation
                  </Button>
                </div>
              </FieldBody>
            </Field>
          ))}

          <Button
            className='small-margin'
            variant='tertiary'
            size='small'
            style={{ paddingTop: '0px', marginTop: '0px' }}
            onClick={addBusinessLineField}
          >
            + Add Allocation
          </Button>
          <div>
            <div className='totalPercent'>
              Total Percentage:{' '}
              <span
                style={{
                  color: !acceptedPercentages.includes(totalAllocation) ||
                  (
                    businessLineAllocationList[0].businessLineReportUnitCompanyCode != 0 &&
                    totalAllocation != '100.00'
                  )
                  ? 'red' : '',
                }}
              >
                {totalAllocation} %
              </span>
            </div>
          </div>
        </Fieldset>
      </div>
      <div>
        <div>
          <Fieldset>
            {epsBusinessLineAllocationList.map((epsBusinessLineAllocation, index) => (
              <Field
                key={`${epsBusinessLineAllocation}~${index}`}
                style={{ height: '100px' }}
              >
                <FieldLabel></FieldLabel>
                <FieldBody>
                  <div className='detail-row'>
                    <Select
                      selectProps={{
                        className: 'bs-line-category'
                      }}
                      style={{ paddingLeft: '15px'}}
                      label='Value Chain'
                      value={epsBusinessLineAllocation.businessValueChain}
                      onChange={(e) =>
                        handleEPSBusinessLineObjChange('epsBusinessValueChain', index, e)
                      }
                    >
                      <option value=''>Select</option>
                      {epsBusinessValueChainDropdown.map(
                        renderEPSBusinessValueChainDropdown
                      )}
                    </Select>

                    <Select
                      selectProps={{
                        className: 'bs-line-select',
                      }}
                      style={{ paddingLeft: '15px' }}
                      label='E&PS Business Line'
                      value={epsBusinessLineAllocation.businessLine}
                      error={
                        epsBusinessLineAllocation.eps_business_vc_id &&
                        epsBusinessLineAllocation.eps_business_line_id === 0
                      }
                      onChange={(e) =>
                        handleEPSBusinessLineObjChange('epsBusinessLine', index, e)
                      }
                    >
                      <option value=''>Select</option>
                      {epsBusinessLineDropdown
                        .filter((x) =>
                          x.eps_business_vc_id ===
                          parseInt(epsBusinessLineAllocation.eps_business_vc_id)
                        )
                        .map(renderEPSBusinessLineDropdown)}
                    </Select>

                    <TextInput
                      className='bs-line-allocation'
                      label='Allocation %'
                      value={epsBusinessLineAllocation.epsAllocationPercent.toString()}
                      onChange={(e) => handleEPSBusinessLineObjChange('epsAllocation', index, e)}
                      onFocus={(e) => handleAllocationFocus('epsAllocation', index, e)}
                      onBlur={(e) => handleAllocationFocus('epsAllocation', index, e)}
                      error={
                        (
                          epsBusinessLineAllocationList[parseInt(index)].eps_business_vc_id &&
                          (
                            epsBusinessLineAllocationList[parseInt(index)].epsAllocationPercent == 0 || /* == includes 0 and "0" */
                            epsBusinessLineAllocationList[parseInt(index)].epsAllocationPercent === ''
                          )
                        )
                      }
                    />

                    <Button
                      style={{ paddingTop: '42px', paddingLeft: '30px' }}
                      className='small-margin'
                      variant='tertiary'
                      size='small'
                      onClick={() => removeEPSBusinessLineField(index)}
                    >
                      × Remove EPS Allocation
                    </Button>
                  </div>
                </FieldBody>
              </Field>
            ))}

            <Button
              className='small-margin'
              variant='tertiary'
              size='small'
              style={{ paddingTop: '0px', marginTop: '0px' }}
              onClick={addEPSBusinessLineField}
            >
              + Add EPS Allocation
            </Button>
            <div>
              <div className='totalPercent'>
                Total Percentage:{' '}
                <span
                  style={{
                    color:
                      !acceptedPercentages.includes(totalEpsAllocation) ||
                      (
                        epsBusinessLineAllocationList[0].eps_business_vc_id != 0 &&
                        totalEpsAllocation !== '100.00'
                      )
                      ? 'red' : '',
                  }}
                >
                  {totalEpsAllocation} %
                </span>
              </div>
            </div>
          </Fieldset>
        </div>
        <div>
          <ProgressTabNavigator
            onNavigateBackward={onNavigateBackward}
            onNavigateForward={onNavigateForward}
          > 
          </ProgressTabNavigator>
        </div>
      </div>

    </div>
  );
}
export default LocationBusinessLine;
